angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsDashboard', function (
  $log,
  $q,
  language,
  EventManager,
  API_CONFIG,
  PanelFactory,
  TeacherDataService,
  $timeout,
  LocaleService,
  api,
  preliveCheck,
  $interval,
  userAccount,
  apiMethods,
  $http,
  ModuleFilter,
  PlatformService,
  cordovaMessenger,
  $rootScope,
  URL_VERSIONS,
  GenericPopup
) {

  return {

    templateUrl: 'template.html',

    scope: {
      selectedClass: '='
    },
    link: function (scope, element) {
      scope.isModuleAvailable = (module) => {
        // $log.log('module being checked', module)
        return ModuleFilter.checkAvailable(module);
      }

      scope.isPrelive = function(){
        return preliveCheck.isPreliveCheck();
      }
      scope.archivedStudents = [];
      scope.showActiveStudents = true;
      scope.filters = {};
      var resetFilter = function(){
        scope.filters = {
          perspective: 'modules'
        }
      }
      scope.sort = {
        order:'ASC',
        by:'first_name',
        prevSortBy:'first_name'
      }
      scope.editStudent = {
        showModal: false,
        activeStudent: null
      }
      scope.archivedStudents = {
        showModal: false
      }
      scope.addStudents = {
        showModal: false
      }
      scope.pdfGeneration = {
        isGeneratePdfModalVisible:false,
        selectedStudent:{},
        showExportDate:false
      }
      scope.agendaData = {
        isLoading: false,
        isLoaded:  false,
        data: null,
      }

      // event manager
      var eventManager = new EventManager('teacherStudentsDashboard', scope);

      scope.closeEditStudent = function(){
        scope.editStudent = {
          showModal: false
        }
      }
      scope.startEditStudent = function(student){
        scope.editStudent.showModal = true;
        scope.editStudent.activeStudent = student
        // student.user.user_id
      }

      scope.getStudenName = function(student){
        return student.user.info.first_name+" "+student.user.info.last_name
      }

      scope.load_workspace = function(student, module){
        // $log.log('broadcasting!', student, module )
        eventManager.broadcast('dashboard:to:workspace', {student, module})
        scope.focusOnDiagnosticMode = false;
      }

      scope.resetStudentPassword = function(student, password){
        scope.editStudent.updating_password = true;
        scope.editStudent.show_password_feedback = null;
        api.postUserPasswordUpdate(student.user.user_id, password, userAccount.getActiveClassData().id)
        .then(function(resonse){
          scope.editStudent.newPassword = null;
          scope.editStudent.showPasswordreset = false;
          scope.editStudent.updating_password = false;
          scope.editStudent.show_password_feedback = 'Password has been changed';
        }).catch(function(err){
          scope.editStudent.newPassword = null;
          scope.editStudent.showPasswordreset = false;
          scope.editStudent.updating_password = false;
          scope.editStudent.show_password_feedback = 'There was an error updating the password';
        })
      }

      eventManager.listen('filters:to:dashboard', function(e, args){
        scope.focusOnDiagnosticMode = false;
        scope.filters.perspective = args.perspective;
        if (args.agendaFocus){
          scope.filters.agendaFocus = args.agendaFocus;
          init(scope.selectedClass, true, true)
          //scope.updateAgendaData(true);
        }

        $timeout(function() {
          scope.onDashboardViewChange();
        }, 4000);
      });

      scope.showGeneratePDFModal = function(student){
        scope.pdfGeneration.isGeneratePdfModalVisible = true;
        scope.pdfGeneration.selectedStudent = student;
      }

      scope.found_img = false;
      scope.agendaTopRowHeight = 136;
      scope.getItemImage = function(item){
        scope.found_img = scope.found_img || PanelFactory.getItemImage(item) ? true : false;
        scope.agendaTopRowHeight = scope.found_img ? 200 : 136;
        return PanelFactory.getItemImage(item);
      }


      scope.getModuleIconAssetUrl = function(item_slug, item_parent_resource_id){
        if(scope.meta_mod && scope.meta_mod[0].config && scope.meta_mod[0].config.map_config && scope.meta_mod[0].config.map_config.set_module_icon_names){
          var asset_name = scope.meta_mod[0].config.map_config.set_module_icon_names[item_slug] || scope.meta_mod[0].config.map_config.set_module_icon_names.default;
          return scope.meta_mod[0].config.map_config.asset_url + asset_name + ".png";
        }else{          
          return PanelFactory.getModuleIconAssetUrl(item_slug, item_parent_resource_id);
        }
      };

      var getProgressRingForPdf = function(size, score, lock){
        var url = 'https://s3.eu-central-1.amazonaws.com/mtic-items/interface/';
        if (lock){
          url += 'teachview-ring-'+size+'-locked.png'
        }
        else{
          var num = score ? Math.min(21 , Math.round(21*score)) : 0;
          if (num === 0){
            url += 'teachview-ring-'+size+'-blank.png'
          }
          else{
            if ( String(num).length === 1){
              num = '0'+num;
            }
            url += 'teachview-ring-'+size+'-fill00'+num+'.png'
          }
        }
        return url;
      }



      var createRingImage = function(imageSource,imageWidth,imageStartPositionX,imageStartPositionY,specialElementHandlers,doc){
        var defer = $q.defer();
        var img = document.createElement('img');//new Image(); // width, height values are optional params
        img.width = imageWidth;
        img.src = imageSource;
        img.style.display = "inline-block";
        img.setAttribute("style", "display : inline");
        var body = document.createElement("body");
        body.appendChild(img);
        doc.fromHTML( body, imageStartPositionX, imageStartPositionY, {
          'width': 10, // max width of content on PDF
          'elementHandlers': specialElementHandlers
        }, function(bla) {
          // $log.log(bla);
          defer.resolve();
        });

        return defer.promise;
      }

      scope.downloadStudentProgressPdf = function(student,shouldShowExportDate){
        if(scope.pdfGeneration.generatingPdf){
          return;
        }
        scope.pdfGeneration.generatingPdf =true;
        var name = student.user.info.first_name+" "+student.user.info.last_name;
        var doc = new jsPDF();
        doc.text(20, 20, "Name: "+name);
        doc.text(20, 30, "Class: "+scope.selectedClass.name);
        if(shouldShowExportDate){
          doc.text(20, 40, "Date of Export: "+moment().format('YYYY-MM-DD'));
        }

        var promises = [];
        angular.forEach(scope.modules,function(each,index){
          var stats = student.moduleWorkSummary[each.resource_id].stats;
          var specialElementHandlers = {
            '#editor': function(element, renderer){
              return true;
            },
            '.controls': function(element, renderer){
              return true;
            }
          };
          var starty = 60;
          doc.text(20, starty+10+(index*20), scope.getModuleName(each));
          var startx = 120;
          var firstProgressRingSrc = getProgressRingForPdf('small', stats.diagnostic.score_max_mean, stats.diagnostic.locked);
          var secondProgressRingSrc = getProgressRingForPdf('large', stats.lessons.score_max_mean, stats.diagnostic.locked);
          var thirdProgressRingSrc = getProgressRingForPdf('small', stats.summative.score_max_mean, stats.summative.locked);
          promises.push(createRingImage(firstProgressRingSrc,"10",startx,starty+2.5+(index*20),specialElementHandlers,doc));
          promises.push(createRingImage(secondProgressRingSrc,"15",startx+10,starty+(index*20),specialElementHandlers,doc));
          promises.push(createRingImage(thirdProgressRingSrc,"10",startx+10+15,starty+2.5+(index*20),specialElementHandlers,doc));
        });

        $q.all(promises).then(function(){
          doc.save(scope.selectedClass.id+"_"+student.user.user_id+'.pdf')
          scope.pdfGeneration ={};
        },function(err){
          scope.pdfGeneration.generatingPdf = false;
        });
      }

      scope.changeSortOrder = function(by,order){
        if(by==='FIRST_NAME'){
          scope.sort.by = 'first_name';
        }
        if(by==='LAST_NAME'){
          scope.sort.by = 'last_name';
        }
        scope.sort.order = (order==='ASC')&&(scope.sort.prevSortBy===scope.sort.by)?'DESC':'ASC';
        scope.sort.prevSortBy = scope.sort.by;
      }

      scope.customOrder = function(){
        var sortOrder = scope.sort.order==="ASC"?'-':'';
        var sortString = (sortOrder||"")+"user.info."+scope.sort.by;
        // $log.log(sortString);

        return sortString;
      }

      scope.timeSecToMin = function(seconds){
        if(!seconds || isNaN(seconds)){
          return 0;
        }
        return Math.max(1 , Math.floor(seconds/ 60000));
      }

      scope.decToPerc = function(dec){
        if (dec || dec === 0){
          return Math.floor(dec*100)+'%'
        }
        else{
          return '0%'
        }
      }

      scope.getTranslation = function(id, fallbackText){
        if (fallbackText) {
          return language.get(id) !== "NA" ? language.get(id) : fallbackText;
        }

        return language.get(id);
      }

      scope.onFilterPerspectiveChange = function(){
        scope.focusOnDiagnosticMode = false;
        // $log.log('onFilterPerspectiveChange', scope.filters.perspective)
        if (scope.filters.perspective === 'agenda'){
          scope.updateAgendaData(true);

          if (!scope.filters.agendaFocus){
            scope.filters.agendaFocus = 'overview';
          }
          if(scope.currentSelectedAgenda){
            eventManager.broadcast("teacher:select:dropdown", {"dashboard": "Agenda", "group_id": currentClassroom.id, "agenda_id": scope.currentSelectedAgenda.id });
          }
        }
        else {
          scope.agendaTopRowHeight = 136;
          eventManager.broadcast("teacher:select:dropdown", {"dashboard": "Modules", "group_id": currentClassroom.id, "resource_id": TeacherDataService.currentActiveMeta.resource_id });
        }
        $timeout(function(){
          scope.onDashboardViewChange();
        }, 66)

      }

      scope.$watch('filters.agendaFocus', function(val){
        scope.focusOnDiagnosticMode = false;
        if(!val || !scope.agendaData || !scope.agendaData.data){
          return;
        }
        scope.agendaData.data.forEach(function(agenda){
          if(agenda.id === val){              
            scope.found_img = false;
            scope.currentSelectedAgenda = agenda;

            $timeout(function(){
              scope.onDashboardViewChange();
              eventManager.broadcast("teacher:select:dropdown", { "dashboard": "Agenda", "group_id": currentClassroom.id, "agenda_id": agenda.id});
            }, 66)
            // $log.log('AGENDA : '  , agenda)
          }
        })
      })
      scope.studentsAgendaFilter = function(student){
        return scope.filters.agendaFocus === 'overview' || (scope.currentSelectedAgenda && (scope.currentSelectedAgenda.is_for_all_class || scope.currentSelectedAgenda.students.indexOf(student.user.user_id) > -1));
      }

      scope.archiveStudent = function(student){
        student.isArchiving = true;
        api.archiveStudent(scope.selectedClass.id, student.user.user_id, true)
        .then( function(){
          student.isArchived = true;
          student.isRestored = false;
          scope.students = _.filter(scope.students,function(student){
            return !student.isArchived;
          });
          scope.archivedStudents.push(student.user);
          student.isArchiving = false;
          scope.closeEditStudent();
        })
      }

      scope.restoreStudent = function(student){
        student.isRestoring = true;
        api.archiveStudent(scope.selectedClass.id, student.user_id, false)
        .then( function(){
          student.isRestored = true;
          student.isArchived = false;
          scope.archivedStudents = _.filter(scope.archivedStudents,function(student){
            return !student.isArchived;
          });
          scope.students.push(student);
          student.isRestoring = false;
          scope.refresh();
        })
      }

      // TeacherDataService.getUserClasses().then(function(classes){
      //   scope.classes = classes;
      //   scope.$watch('selectedClass', function(classroom){
      //     if (classroom){
      //       // $log.log('selectedClass : ', classroom)
      //       eventManager.broadcast('teacherStudentsAgenda:init', classroom.id);
      //       scope.resetAgendaModalState();
      //       scope.view_controller.reset();
      //     }
      //   });
      // });

      scope.updateAgendaData = function(fromDashboard){
        // $log.log('updateAgendaData', scope.agendaData.isLoaded, scope.agendaData.isLoading)
        var isClassAgendaInFocus = scope.agendaData.classId === currentClassroom.id;
        var isAgendaLoadingOrLoaded = scope.agendaData.isLoading || scope.agendaData.isLoaded
        // StudentAgendaItems.i.{resource_id, resource_completed, user_id, resource_timespent}
        if(!(isClassAgendaInFocus && isAgendaLoadingOrLoaded) ){
          scope.agendaData.isLoading = true;
          scope.agendaData.isLoaded = false;
          scope.agendaData.classId = currentClassroom.id;
          scope.agendaData.data = null;
          // $log.log('updateAgendaData id ', currentClassroom.id);
          TeacherDataService.getClassAgendas(currentClassroom.id, true)
          .then( function(res){
            scope.agendaData.isLoading = false;
            // scope.agendaData.isLoaded = true;
            processAgendaDataForDashboard(res, fromDashboard)


          })
          .then( function(res){
            // $log.log('updateAgendaData fail', res)
          });
        }
      }

      function dateOpenSort(a,b) {
        if (a.startTime.getTime() < b.startTime.getTime()){
            return -1;
        }
        if (a.startTime.getTime() > b.startTime.getTime()){
            return 1;
        }
        return 0;
      }

      var processAgendaDataForDashboard = function(data, fromDashboard){
        scope.agendaData.data = data;

        var agendaRef = {};

        data.forEach(function(agenda){
          agenda.startTime = new Date(agenda.date_open);
          agenda.endTime = new Date(agenda.date_close);
        });

        data = data.sort(dateOpenSort);

        _.each(data, function(agendaData){
          if (agendaData.description.length > 27) {
            agendaData.description = agendaData.description.slice(0, 27) + "...";
          }

          if (!agendaData.archived){
            // to do: need to respect order of custom units... although this should be sorted at the time of save
            var resourceRefs = agendaData.resourceRefs;
            if(resourceRefs[0].slug.indexOf('run_like_math') > -1){
              resourceRefs.sort(function(a,b){
                return Number(a.slug.split('_')[a.slug.split('_').length -1]) > Number(b.slug.split('_')[b.slug.split('_').length -1]) ? 1 : -1;
              })
            }
            var studentPerformances = {};
            if(agendaData.force_redo){
              _.each(agendaData.StudentAgendaItems, function(perf){
                var studentPerformance = studentPerformances[perf.user_id];
                if (!studentPerformance){
                  studentPerformance = studentPerformances[perf.user_id] = {
                    time_cummul: 0,
                    score_cummul: 0,
                    completion_cummul: 0,
                    completions: {},
                    scores: {},
                  }
                }
                // $log.log('checking time  : ', perf.resource_timespent)
                studentPerformance.time_cummul += Math.min(1200000, Math.max(0,perf.resource_timespent));
                studentPerformance.score_cummul += perf.resource_performance;
                if (perf.resource_completed){ studentPerformance.completion_cummul += 1; }
                studentPerformance.completions[perf.resource_id] = perf.resource_completed;
                studentPerformance.scores[perf.resource_id] = perf.resource_performance;
                if (resourceRefs){
                  studentPerformance.completionsPerc = studentPerformance.completion_cummul / resourceRefs.length;
                  studentPerformance.scoresPerc = studentPerformance.score_cummul / resourceRefs.length ;
                }
              })
            }else{
              //$log.log('student_completion_map : ', student_completion_map)
              var student_arr = agendaData.students;
              if(agendaData.is_for_all_class){
                scope.students.forEach(function(std){
                  student_arr.push(std.user.user_id);
                })
              }
              student_arr.forEach(function(student){
                var studentPerformance = studentPerformances[student];
                if (!studentPerformance){
                  studentPerformance = studentPerformances[student] = {
                    time_cummul: 0,
                    score_cummul: 0,
                    completion_cummul: 0,
                    completions: {},
                    scores: {},
                  }
                }
                agendaData.resources.forEach(function(resource){
                  if(student_completion_map[student] && student_completion_map[student][resource]){
                    var close_time = new Date(agendaData.date_close).getTime();
                    var resource_time = new Date(student_completion_map[student][resource].time_stamp_last).getTime();
                    //$log.log('COMPARING : ', close_time, resource_time)
                    studentPerformance.completions[resource] = student_completion_map[student][resource].completed && close_time > resource_time;
                    if(studentPerformance.completions[resource]){
                      studentPerformance.completion_cummul += 1;
                      studentPerformance.time_cummul += Math.min(1200000, Math.max(0, student_completion_map[student][resource].time_spent));
                      studentPerformance.scores[resource] = student_completion_map[student][resource].score;
                      studentPerformance.score_cummul += student_completion_map[student][resource].score;
                    }
                  }
                })
                studentPerformance.completionsPerc = studentPerformance.completion_cummul / agendaData.resources.length;
                studentPerformance.scoresPerc = studentPerformance.score_cummul / agendaData.resources.length ;
              })
            }
            agendaRef[agendaData.id] = {
              resourceRefs: resourceRefs,
              studentPerformances: studentPerformances
            }
          }
        })
        scope.agendaData.units = agendaRef;
        if(fromDashboard){
          scope.agendaData.data.forEach(function(agenda){
            if(agenda.id === scope.filters.agendaFocus){
              scope.currentSelectedAgenda = agenda;
            }
          })
        }else{
          if(scope.agendaData.data.length > 0){
            scope.filters.agendaFocus = scope.agendaData.data[0].id;
          }
        }
      }

      scope.getName = function(slug, full_resource){
        if(full_resource){
          if(slug.resource_type === 'custom_resource'){
            return slug.name;
          }
          slug = slug.slug;
        }
        if(slug === 'run_like_math' || slug.indexOf('run_like_math') === -1 || slug.indexOf('lv_') === -1){
          return language.get(slug)
        }else{
          var splt = slug.split('_');
          var level = '';
          if(!isNaN(splt[splt.length-1])){
            level = splt[splt.length-1];
          }
          var trans_slug = slug.replace('_'+level, '');
          return language.get(trans_slug)+ ' ' + level;
        }
        //return language.get(slug);
      }
      
      var name_color_map = {'red': '#E04356', 'blue': '#005BF3', 'black':'#3D3D3D'}
      scope.getNameColor = function(resource){
        if(!resource.display || !resource.display.color){
          return '#000'
        }
        return name_color_map[resource.display.color]
      }

      // TeacherDataService.getModuleListFlat(classroom.id);
      // TeacherDataService.getClassStats(classroom.id,true);
      // TeacherDataService.getClassAgendas(class_id)

      // this
      scope.warning_timer_delay = false;
      $timeout(function(){
        scope.warning_timer_delay = true;
      }, 1000)



      // model
      scope.loadingStatus = {
        done: false,
        failed: false
      }
      scope.refresh = function(){
        init(scope.selectedClass, true)
      }
      scope.getModuleName = function(module){
        var name = language.get(module.slug);
        if(!name) {
          name = module.slug;
        }
        return name;
      }

      scope.language = language;
      var student_completion_map;
      var init = function(classroom, reset, toAgendas){
        scope.loadingStatus.done = false;
        scope.loadingStatus.failed = false;
        scope.students = [];

        student_completion_map = {};
        api.getClassResourceStates(classroom.id,false,true).then(function(data){
          data.forEach(function(student_data){
            student_completion_map[student_data.user_id] = {};
            student_data.User.ClassWorks.forEach(function(work){
              var res_id = work.WorkBatch.Resource.id;
              if(!student_completion_map[student_data.user_id][res_id]){
                student_completion_map[student_data.user_id][res_id] = {};
              }
              if (work.WorkBatch.StudentResourceState) {
                student_completion_map[student_data.user_id][res_id].completed = work.WorkBatch.StudentResourceState.complete;
                student_completion_map[student_data.user_id][res_id].time_stamp_last = work.WorkBatch.StudentResourceState.time_stamp_last;
                student_completion_map[student_data.user_id][res_id].time_spent = work.WorkBatch.StudentResourceState.time_spent_total;
                student_completion_map[student_data.user_id][res_id].score = work.WorkBatch.StudentResourceState.score_max;
              }
              else {
                student_completion_map[student_data.user_id][res_id].completed = false;
                student_completion_map[student_data.user_id][res_id].time_stamp_last = "now()";
                student_completion_map[student_data.user_id][res_id].time_spent = 0;
                student_completion_map[student_data.user_id][res_id].score = 0;
              }
            })
          })
        })
        var trueCondition = true === true;
        $q.all([
          TeacherDataService.getModuleListFlat(classroom.id)
          .then(function(modules){
            scope.modules = modules.filter(function(module){
              return !module.hasSubModules && ModuleFilter.checkAvailable(module);
            });
            scope.meta_mod = modules.filter(function(module){
              return module.slug.indexOf('_meta') > -1;
            });
            if(!scope.meta_mod || scope.meta_mod.length === 0){
              scope.meta_mod.push(modules[0]);
            }
            TeacherDataService.currentActiveMeta = scope.meta_mod[0];
            return;
          }),
          TeacherDataService.getClassStats(classroom.id,true)
          .then(function(studentWork){
            scope.students = studentWork;

            // $log.log('students in dashboard: ', scope.students);

          }),
          TeacherDataService.getArchivedStudents(classroom.id)
          .then(function(studentWork){
            // $log.log('GOT ARCHIVED STUFF : ', studentWork)
            scope.archivedStudents = studentWork;
          })
        ])
        .then(function(){
          //herE!!!!!!!
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = false;
          scope.runScrollTableSetUp();

          if(toAgendas){
            scope.updateAgendaData(true);
          }
        })
        // Mobile View
        .then(function(){
          if(window.getComputedStyle(document.querySelector('.mobile-view')).display !== 'none'){
            scope.mStudentStats = getMobileStudentStats();
            scope.modules.splice(0, 0, {
              resource_id: 'overall',
              slug: 'Overall'
            });
            scope.mSelectedModule = scope.modules[0];
            scope.mSortStudentsBy('first_name');

            // Student Profile Modules list
            var sModules = scope.modules.slice(1);
            sortArrayBy(sModules, 'name');
            scope.mStudentProfileModules = sModules;
          }
        })
        .catch(function(){
          scope.loadingStatus.done = true;
          scope.loadingStatus.failed = true;
        })
      };

      /******************************** Mobile View *********************************/

      /****** Setting Dashboard table height *****/
      scope.mEls = scope.mEls || {};
      var unwatch_dashboardTable = scope.$watch(()=>{
        if(!PlatformService.isMobile) {return false}
        scope.mEls.pageHeader = (scope.mEls.pageHeader || document.querySelector('#nav-display-for-certificate'));
        scope.mEls.dashboardHeader = (scope.mEls.dashboardHeader || document.querySelector('.mobile-view .dashboard-header'));
        scope.mEls.dashboardTable = (scope.mEls.dashboardTable || document.querySelector('.mobile-view .dashboard-table'));
        scope.mEls.footer = (scope.mEls.footer || document.querySelector('.dashboard-bottom-buttons'));
        return !!(scope.mEls.pageHeader && scope.mEls.dashboardHeader && scope.mEls.dashboardTable && scope.mEls.footer);
      },(rendered)=>{
        if(rendered){
          setDashboardTableHeight();
          unwatch_dashboardTable();
        }
      });
      function setDashboardTableHeight(){
        let remHeight = 0;
        [scope.mEls.pageHeader, scope.mEls.dashboardHeader, scope.mEls.footer].map((el)=>{remHeight += el.getBoundingClientRect().height});
        scope.mEls.dashboardTable.style.height = (window.innerHeight - remHeight) + 'px';
        mSetDropdownMenuHeight('.mobile-view .dashboard-table', '.module-dropdown');
      }
      window.removeEventListener('resize', mOnResize_dashboardTable);
      window.addEventListener('resize', mOnResize_dashboardTable);
      function mOnResize_dashboardTable(){ // in case for some reason mobile browser changes visible viewport height (hides address bar etc)
        if(PlatformService.isMobile){
          setDashboardTableHeight();
          setDashboardTableHeaderHeight();
        }
      }
      /*** End of Setting Dashboard table height ***/

      function getMobileStudentStats(){
        var stats = {};
          scope.students.map(function(student){
            var studentId = student.user.user_id;
            var studentStats = stats[studentId] = {};
            var totalDiagnostic = 0, totalLessons = 0, totalSummative = 0;
            scope.modules.map(function(module){
              var moduleId = module.resource_id;
              var wStats = student.moduleWorkSummary[moduleId].stats,
                  diagnostic = Math.round(wStats.diagnostic.score_max_mean * 100),
                  lessons = Math.round(wStats.lessons.score_max_mean * 100),
                  summative = Math.round(wStats.summative.score_max_mean * 100);
              studentStats[moduleId] = {
                'diagnostic': {
                  'value': diagnostic,
                  'color': getChartColor(diagnostic),
                  'score_max_mean': wStats.diagnostic.score_max_mean
                },
                'lessons': {
                  'value': lessons,
                  'color': getChartColor(lessons),
                  'score_max_mean': wStats.lessons.score_max_mean
                },
                'summative': {
                  'value': summative,
                  'color': getChartColor(summative),
                  'score_max_mean': wStats.summative.score_max_mean
                }
              };
              totalDiagnostic += studentStats[moduleId].diagnostic.value;
              totalLessons += studentStats[moduleId].lessons.value;
              totalSummative += studentStats[moduleId].summative.value;
            });
            var overallDiagnostic = Math.round(totalDiagnostic / scope.modules.length),
                overallLessons = Math.round(totalLessons / scope.modules.length),
                overallSummative = Math.round(totalSummative / scope.modules.length);
            studentStats.overall = {
              'diagnostic': {
                'value': overallDiagnostic,
                'color': getChartColor(overallDiagnostic),
                'score_max_mean': (overallDiagnostic / 100)
              },
              'lessons': {
                'value': overallLessons,
                'color': getChartColor(overallLessons),
                'score_max_mean': (overallLessons / 100)
              },
              'summative': {
                'value': overallSummative,
                'color': getChartColor(overallSummative),
                'score_max_mean': (overallSummative / 100)
              }
            }
          });
        return stats;
      }
      function getChartColor(val){
        var color = '';
        if(val <= 50){ color = 'red'}
        else if(50 < val && val <= 80){ color = 'yellow'}
        else {color = 'green'}
        return color;
      }

      function getUnitValue(str, unit){
        let index = str.indexOf(unit || 'px');
        return  (index !== -1) ? str.substring(0, index) : null
      }

      scope.$watch('mSelectedModule', function(module){
        setDashboardTableHeaderHeight();
      });

      function setDashboardTableHeaderHeight(){
        /********* Dynamic height for Dashboard table header on phones *************/
        scope.mTableHeaderEl = scope.mTableHeaderEl || document.querySelector('.dashboard-table .table-header');
        var headerStyle = window.getComputedStyle(scope.mTableHeaderEl);
        scope.mModuleCaptionEl = scope.moduleLabelEl || document.querySelector('.module-dropdown .dropdown-toggle .caption');
        var captionStyle = window.getComputedStyle(scope.mModuleCaptionEl),
          headerHeightRatio = PlatformService.isPhonePortrait() ? 1.2 : 1,
          minHeaderHeight_vw = PlatformService.isPhonePortrait() ? 13.8 : 5.5,
          minHeaderHeight = (window.innerWidth * minHeaderHeight_vw) / 100,
          captionHeight = Number(getUnitValue(captionStyle.height)),
          headerHeight = Number(getUnitValue(headerStyle.height));
        if(captionHeight > minHeaderHeight){
          scope.mTableHeaderEl.style.height = (captionHeight * headerHeightRatio) + 'px';
        }
        else{
          scope.mTableHeaderEl.style.height =  minHeaderHeight + 'px';
        }
        /******** End of Dynamic height for Dashboard table header on phones ********/
      }

      /**
       * Calculates height for dropdown menu
       * @param containerSelector Container element to base available height against.
       * @param dropdownSelector Dropdown selector
       * @param pct Percentage of container height to use.
       */
      function mSetDropdownMenuHeight(containerSelector, dropdownSelector, pct){
        var container = document.querySelector(containerSelector);
        var menu = container.querySelector(dropdownSelector + ' .dropdown-menu');
        var defaultPct = 0.8;
        pct = pct || defaultPct;
        var maxMenuHeight = (container.offsetHeight * pct) + 'px';
        menu.style['max-height'] = maxMenuHeight;
      }

      scope.mSortByToggle = function(){
        scope.mSortByOpened = !scope.mSortByOpened;
      };
      scope.mSortStudentsBy = function(id){
        scope.mSelectedSortBy = id;
        scope.mSortByOpened = false;
        scope.students.sort(function(a, b){
          var va = a.user.info[id],
              vb = b.user.info[id];
          if(va > vb){return 1;}
          else if(va < vb){return -1;}
          else {return 0;}
        });
        mScrollTopStudents();
      };
      function sortArrayBy(arr, prop, desc){
        if((!Array.isArray(arr)) || !prop) {
          return;
        }
        arr.sort(function(a, b){
          var va = a[prop],
            vb = b[prop];
          if(desc === true){
            if(va < vb){return 1;}
            else if(va > vb){return -1;}
            else {return 0;}
          }
          else{
            if(va > vb){return 1;}
            else if(va < vb){return -1;}
            else {return 0;}
          }
        });
      }
      scope.mSelectModule = function(module){
        scope.mSelectedModule = module;
        scope.mModuleDropdownOpened = false;
        mScrollTopStudents();
      };
      scope.mSelectStudent = function(student){
        scope.mSelectedStudent = student;
        scope.mStudentDropdownOpened = false;
        if(scope.mActiveStudentProfileTab.id === 'studentPerformance'){
          mScrollTopTopics();
        }
      };
      function mScrollTopStudents(){
        document.querySelector('.dashboard-table .table-contents').scrollTop = 0;
      }
      function mScrollTopTopics(){
        document.querySelector('.performance-container .table-contents').scrollTop = 0;
      }
      scope.mModuleToggle = function(){
        scope.mModuleDropdownOpened = !scope.mModuleDropdownOpened;
      };

      closeOnOutsideClick('mModuleDropdownOpened', '.module-dropdown');
      closeOnOutsideClick('mSortByOpened', '.sort-by-dropdown');
      closeOnOutsideClick('mStudentDropdownOpened', '.student-dropdown');

      /**
       * Registers closing of dropdown when clicked outside of dropdown.
       * @param toggleProperty Scope property which toggles dropdown opened state.
       * @param dropdownSelector Dropdown selector.
       */
      function closeOnOutsideClick(toggleProperty, dropdownSelector){
        scope.$watch(toggleProperty, (opened)=>{
          var handlerName = 'documentClick_close_' + toggleProperty;
          if(opened){
            document.addEventListener('click', scope[handlerName])}
          else{
            document.removeEventListener('click', scope[handlerName])}

          scope[handlerName] = scope[handlerName] || function(e){
            if(!document.querySelector(dropdownSelector).contains(e.target)){ // ignore clicks from within dropdown
              e.preventDefault();
              e.stopImmediatePropagation();
              scope.$apply(function(){
                scope[toggleProperty] = false;
              });
            }
          }
        });
      }

      /**
       * Calculate height for specified element to fit the remaining available viewport height on Student Profile modal.
       * @param overflowElName Name used to identify the DOM element in scope.mEls
       * @param overflowElSelector Element selector.
       */
      function setStudentProfileElementHeight(overflowElName, overflowElSelector){
        scope.mEls = scope.mEls || {};
        var unwatch = scope.$watch(()=>{
          if(!PlatformService.isMobile) {return false}
          scope.mEls.studentProfileHeader = document.querySelector('.mobile-view .student-profile .profile-header');
          scope.mEls.studentProfileTop = document.querySelector('.mobile-view .student-profile .profile-body .top-section');
          scope.mEls[overflowElName] = document.querySelector(overflowElSelector);
          return !!(scope.mEls.studentProfileHeader && scope.mEls.studentProfileTop && scope.mEls[overflowElName]);
        },(rendered)=>{
          if(rendered){
            setOverflowElementHeight();
            unwatch(); // Kill the watcher - no need to keep running once the height has been set!!
          }
        });
        function setOverflowElementHeight(){
          let remHeight = 0;
          let bottomPaddingRatio = PlatformService.isPhonePortrait() ? 0.02 : 0.01;
          let bottomPadding = window.innerWidth * bottomPaddingRatio;
          [scope.mEls.studentProfileHeader, scope.mEls.studentProfileTop].map((el)=>{remHeight += (el ? el.getBoundingClientRect().height : 0)});
          scope.mEls[overflowElName].style.height = (window.innerHeight - remHeight - bottomPadding) + 'px';
        }
        // Recalculate height in case mobile browser changes visible viewport height (shows/hides address bar, or other elements of browser interface)
        window.removeEventListener('resize', mOnResize_overflowElementHeight);
        window.addEventListener('resize', mOnResize_overflowElementHeight);
        function mOnResize_overflowElementHeight(){
          if(PlatformService.isMobile){
            setOverflowElementHeight()
          }
        }
      }
      function setStudentProfileHeight(tab){
        tab = tab || scope.mActiveStudentProfileTab;
        if(tab.id === 'studentPerformance'){
          setStudentProfileElementHeight('studentModulesTable', '.mobile-view .student-profile .modules-table')
        }
        else if(tab.id === 'manageAccounts'){
          setStudentProfileElementHeight('manageAccountsBody', '.mobile-view .student-profile .profile-body .accounts-container')
        }
      }

      scope.mStudentToggle = function(){
        if(!scope.mStudentDropdownOpened){
          mSetDropdownMenuHeight('.profile-body', '.student-dropdown', 0.7)
        }
        scope.mStudentDropdownOpened = !scope.mStudentDropdownOpened;
      };
      scope.mSortByDropItems = [{
        id: 'first_name',
        title: 'First Name'
      },{
        id: 'last_name',
        title: 'Last Name'
      }];
      scope.mSortByOpened = false;
      scope.mModuleDropdownOpened = false;
      scope.mStudentDropdownOpened = false;
      scope.mStudentProfileDisplayed = false;
      scope.mResetPasswordDisplayed = false;
      scope.mResetPasswordHidden = true;

      scope.mStudentNameClick = function(student){
        scope.mOpenStudentProfile(student);
      };
      scope.$watch('mSelectedStudent', (student)=>{
        if(scope.mStudentProfileDisplayed){
          $timeout(()=>{
            setStudentProfileHeight()
          }, 100)
        }
      });
      scope.mOpenStudentProfile = function(student){
        scope.mSelectedStudent = student;
        setStudentProfileHeight(scope.mStudentProfileTabsById.studentPerformance);
        scope.mActiveStudentProfileTab = scope.mStudentProfileTabsById.studentPerformance;
        scope.mStudentProfileDisplayed = true;
      }
      scope.mCloseStudentProfile = function(){
        scope.mStudentProfileDisplayed = false;
      }
      scope.mOpenResetPassword = function(student){
        scope.mResetPasswordDisplayed = true;
      }
      scope.mCloseResetPassword = function(){
        scope.mResetPasswordDisplayed = false;
      }
      scope.mOpenDeleteStudentDlg = function(student){
        scope.mDeleteStudentDlgDisplayed = true;
      }
      scope.mCloseDeleteStudentDlg = function(){
        scope.mDeleteStudentDlgDisplayed = false;
      }
      scope.mStudentProfileTabs = [
        {
          id: 'studentPerformance',
          label: 'Student Performance'
        },
        {
          id: 'manageAccounts',
          label: 'Manage Accounts'
        }
      ];
      scope.mStudentProfileTabsById = {};
      scope.mStudentProfileTabs.map(function(tab){
        scope.mStudentProfileTabsById[tab.id] = tab;
      });
      scope.mActiveStudentProfileTab = scope.mStudentProfileTabsById.studentPerformance;
      scope.mClickStudentProfileTab = function(tab){
        setStudentProfileHeight(tab);
        scope.mActiveStudentProfileTab = tab;
      }
      scope.mResetStudentPassword = function(student, password){
        scope.mResettingPassword = true;
        api.postUserPasswordUpdate(student.user.user_id, password, userAccount.getActiveClassData().id)
          .then(function(resonse){
            scope.mResettingPassword = false;
            scope.mResetPasswordDisplayed = false;
            GenericPopup.open('Reset Password', 'Password has been changed.');
          }).catch(function(err){
          scope.mResettingPassword = false;
          scope.mResetPasswordDisplayed = false;
          GenericPopup.open('Reset Password', 'There was an error updating the password.');
        })
      }
      scope.mShowHidePassword = function(){
        scope.mResetPasswordHidden = !scope.mResetPasswordHidden;
      }
      scope.$watch('mResetPasswordHidden', function(hidden){
        if(scope.mResetPasswordDisplayed){
          var input = document.querySelector('.mticCard__newPasswordInput');
          input.type = hidden ? 'password' : 'text';
        }
      });
      scope.mDeleteStudent = () => {
        let student = scope.mSelectedStudent;
        scope.mDeletingStudent = true;

        api.archiveStudent(scope.selectedClass.id, student.user.user_id, true)
        .then(function(response){
          student.isArchived = true;
          student.isRestored = false;
          scope.students = _.filter(scope.students,function(student){
            return !student.isArchived;
          });
          scope.archivedStudents.push(student.user);
          scope.mDeletingStudent = false;
          scope.mDeleteStudentDlgDisplayed = false;
          scope.mStudentProfileDisplayed = false;
          GenericPopup.open('Delete Student', 'Student ' + student.user.display_name + ' has been removed from your class.');
        }).catch(function(err){
          scope.mDeletingStudent = false;
          scope.mDeleteStudentDlgDisplayed = false;
          GenericPopup.open('Delete Student', 'There was an error while removing the student from your class.');
        })
      }
      /**************************** End of Mobile View ******************************/

      var currentClassroom;

      TeacherDataService.getUserClasses()
      .then(function(classes){
        scope.classes = classes;
        scope.$watch('selectedClass', function(classroom){
          // $log.log('selectedClass change')
          if (classroom){
            currentClassroom = classroom;
            resetFilter();
            init(classroom);
          }
        });
      });

      //custom filter to order teacher view modules, based on cycle
      scope.customModuleFilter = function(module){
        return module.display && module.display.order ? module.display.order : 0;
      }

      scope.show_info_and_scroll = function(){
        scope.show_add_info = true; scope.warning_timer_delay = true
        $timeout(function(){
          document.getElementById('studentStatsDashboard').scrollTo(0,document.body.scrollHeight);
        },100)
      }

      scope.isLuxUser = function(){
        return LocaleService.getCurrentLocale() === 'LUXEMBOURG';
      }

      scope.resetView = function(){
        eventManager.broadcast('refresh:current:tab')
        resetHorizontalScrollPosition();
        scope.focusOnDiagnosticMode = false;
      }

      // var tableOffset = angular.element(document).find("#table-1").offset().top;
      // var $header = angular.element(document).find("#table-1 > thead").clone();
      // var $fixedHeader = angular.element(document).find("#header-fixed").append($header);

      // angular.element(document).find(window).bind("scroll", function() {
      //   var offset = angular.element(document).find(this).scrollTop();

      //   if (offset >= tableOffset && $fixedHeader.is(":hidden")) {
      //       $fixedHeader.show();
      //   }
      //   else if (offset < tableOffset) {
      //       $fixedHeader.hide();
      //   }
      // });

      eventManager.listen('sidepanel:toggled', function(e, val){
        scope.scrollableWidth -= val ? 200 : -200
      })

      var resizeThrottler = function (){
        var resizeTimeout;
        // ignore resize events as long as an actualResizeHandler execution is in the queue
        if ( !resizeTimeout ) {
          resizeTimeout = $timeout(function() {
            resizeTimeout = null;
            // actualResizeHandler();
            scope.runScrollTableSetUp();
           // The actualResizeHandler will execute at a rate of 15fps
           }, 66);
        }
      }

      var setResizeEventlistener = function() {
        window.addEventListener("resize", resizeThrottler, false);
      }

      setResizeEventlistener();

      scope.$on('$destroy', function() {
        window.removeEventListener("resize", resizeThrottler, false);
        window.removeEventListener('resize', mOnResize_dashboardTable);
      });

      scope.scrollableWidth = 0;

      scope.getScrollableWidth = function (){
        if (document.querySelector('.box-inner')) {
          scope.scrollableWidth = document.querySelector('.box-inner').clientWidth;
          // $log.log('scope.scrollableWidth', scope.scrollableWidth)
        }
      }

      var stop;
      var started = false;
      var boxInner;
      var scrollWidth
      var shownWidth;
      var maxScrollableWidth;
      var fixedHeader;
      var scrollButtonHeldDown = false;

      scope.scrollButtonDown = function (leftClick){
        scrollButtonHeldDown = true;
        scope.leftArrowClick(leftClick)
        window.addEventListener("pointerup", scope.scrollButtonUp, false);
      }
      scope.checkIfIosAndScroll = function(val){
        if(PlatformService.isIos || PlatformService.isAndroid){
          scope.leftArrowClick(val, true)
        }
      }

      scope.scrollButtonUp = function (){
        scrollButtonHeldDown = false;
        window.removeEventListener("pointerup", scope.scrollButtonUp, false);
      }

      scope.scrollTableAtStartPos = true;
      scope.scrollTableAtEndPos = true;

      var setButtonStatus = function() {
        scope.scrollTableAtStartPos = boxInner.scrollLeft === 0;
        scope.scrollTableAtEndPos = boxInner.scrollLeft === maxScrollableWidth;
        // $log.log('boxInner.scrollLeft', boxInner.scrollLeft)
        // $log.log('maxScrollableWidth', maxScrollableWidth)
        // $log.log('scope.scrollTableAtStartPos', scope.scrollTableAtStartPos)
        // $log.log('scope.scrollTableAtEndPos', scope.scrollTableAtEndPos)
      }

      eventManager.listen('sidepanel:toggled', function(e, val){
        $timeout(function() {
          scope.runScrollTableSetUp();
        }, 500);
      });

      scope.onDashboardViewChange = function(){
        if (boxInner) {
          scope.runScrollTableSetUp();
          resetHorizontalScrollPosition();
        } else {
          $timeout(scope.onDashboardViewChange, 100)
        }
      }

      // for when we want to enable native scrolling through dashboard

      // var setScrollListeners = function(){
      //   boxInner.removeEventListener('scroll', syncScrolls)
      //   boxInner.addEventListener('scroll', syncScrolls)
      // }

      // var syncScrolls = function (){
      //   fixedHeader.scrollLeft = boxInner.scrollLeft;
      // }

      var scrollTableWidthCheckAttempts = 0;

      scope.runScrollTableSetUp = function(){
        boxInner = document.querySelector('.scrollTable__scrollDiv');
        fixedHeader = document.querySelector('.scrollTableFixedWrap');

        if(boxInner){
          scrollWidth = boxInner.scrollWidth;
          shownWidth = boxInner.clientWidth;
          maxScrollableWidth = scrollWidth - shownWidth;
          setButtonStatus()
        }

        // To get around the elements not being loaded up in time for the check
        if (scrollTableWidthCheckAttempts !== 3 && scrollWidth === shownWidth) {
          scrollTableWidthCheckAttempts++;
          $timeout(function(){
            scope.runScrollTableSetUp()
          }, 200)
        } else {
          scrollTableWidthCheckAttempts = 0;
        }

        scope.getScrollableWidth();
      }

      var resetHorizontalScrollPosition = function() {
        fixedHeader.scrollLeft = 0;
        boxInner.scrollLeft = 0;
        scope.getScrollableWidth();
        setButtonStatus()
      }

      scope.leftArrowClick = function(leftClick, fast){
        scope.runScrollTableSetUp();
        var speed = 3;
        var timing = fast ? 240 : 60;

        if(started){
          return;
        }

        started = true;
        var dir = leftClick ? -1 : 1;

        var timer = 0;
        stop = $interval(function() {
          if(timer >= timing && !scrollButtonHeldDown){
            $interval.cancel(stop);
            started = false;
            setButtonStatus();
          }else{
            timer += 5;

            fixedHeader.scrollLeft += speed*dir;
            boxInner.scrollLeft += speed*dir;
          }
        }, 5);
      }

      scope.on_student_change = function(new_student){
        if(new_student !== scope.selected_student){
          scope.pdfModal.open(new_student)
        }
      }

      scope.on_qc = function(){
        return scope.meta_mod[0].content.has_formatives;//preliveCheck.isQCCheck();
      }

      scope.download_module_pdf = function(mod, is_diag, resource_id){
        if(pdf_download_disabled){
          window.alert('The PDF download has been temporarily disabled')
          return;
        }

        var user_data = userAccount.getData();
        var class_data = userAccount.getActiveClassData()
        var headers = apiMethods.getAuthHeaders();
        var pdf_data = {
            "session_key": user_data.sessionKey,
            "student_id": scope.selected_student.user.user_id,
            "teacher_id": user_data.user_id,
            "module_id": "2",
            "diagnostic_assessment_resource_id": resource_id,
            "language": language.getCurrentSelectedLanguage(),
            "group_id": class_data.id,
            "auth_group_id": headers['X-Group-Id'],
            "classroom_name": class_data.name,
            "course_slug": scope.meta_mod[0].name,
            "module_slug": mod.slug,
            "student_name": scope.selected_student.user.info.first_name+" "+scope.selected_student.user.info.last_name,
            "teacher_names": user_data.fullName,
            "timezone":moment.tz.guess()
            // "date_from": "1535774400000",
            // "date_start": "1535601600000"
        }
        var params_path = '';
        for(var key in pdf_data){
          params_path += key+'='+encodeURIComponent(pdf_data[key])+'&';
        }

        var pdfUrl = API_CONFIG.PDF_API+'/report-student-diagnostic?'+params_path+'apiUrl='+encodeURIComponent(API_CONFIG.REMOTE_API);
        if (PlatformService.isApp){
          cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: pdfUrl });
        } else {
          var new_win = window.open(pdfUrl,'_blank');
          new_win.location.hash = '';
        }

        var reportType;

        if (is_diag) {
          reportType = "diagnostic";
        }
        else {
          reportType = "summative";
        }

        eventManager.broadcast("teacher:download:pdf", {"resource_id": resource_id, "user_id": user_data.user_id, "module_id": TeacherDataService.currentActiveMeta.resource_id, "report": reportType });
      }

      scope.download_student_pdf = function(){
        if(pdf_download_disabled){
          window.alert('The PDF download has been temporarily disabled')
          return;
        }
        var user_data = userAccount.getData();
        // $log.log('user_data : '  , user_data)
        var class_data = userAccount.getActiveClassData()

        var headers = apiMethods.getAuthHeaders();
        var pdf_data = {
            "session_key": user_data.sessionKey,
            "student_id": scope.selected_student.user.user_id,
            "teacher_id": user_data.user_id,
            "language": language.getCurrentSelectedLanguage(),
            "group_id": class_data.id,
            "auth_group_id": headers['X-Group-Id'],
            "classroom_name": class_data.name,
            "course_slug": scope.meta_mod[0].name,
            "student_name": scope.selected_student.user.info.first_name+" "+scope.selected_student.user.info.last_name,
            "teacher_names": user_data.fullName,
        }

        var params_path = '';
        for(var key in pdf_data){
          params_path += key+'='+encodeURIComponent(pdf_data[key])+'&';
        }

        var pdfUrl = API_CONFIG.PDF_API+'/report-student-overall?'+params_path+'apiUrl='+encodeURIComponent(API_CONFIG.REMOTE_API);
        if (PlatformService.isApp){
          cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: pdfUrl });
        } else {
          var new_win = window.open(pdfUrl,'_blank');
          new_win.location.hash = '';
        }

        eventManager.broadcast("teacher:download:pdf", { "user_id": user_data.user_id, "resource_id": TeacherDataService.currentActiveMeta.resource_id, "report": "learning report" });
      }

      scope.display_students = function(student){
        return student.user.display_name
      }

      scope.assessment_availability_map = {}
      scope.pdfModal = {
        visible: false,
        loading: false,

        open: function(student) {
          scope.assessment_availability_map = {}
          this.loading = true;
          scope.selected_student = student;
          this.visible = true;
          TeacherDataService.getPdfAvailability(scope.selected_student.user.user_id, userAccount.getActiveClassData().id)
          .then(function(data){
            scope.pdfModal.loading = false;
            data.forEach(function(res){
              //var res = log;
              if(res){
                if(!scope.assessment_availability_map[res.parent_resource_id]){
                  scope.assessment_availability_map[res.parent_resource_id] = {}
                }

                if(!scope.assessment_availability_map[res.parent_resource_id][res.config.assessment_type]){
                  scope.assessment_availability_map[res.parent_resource_id][res.config.assessment_type] = []
                }
                var add_assessment = true;
                _.each(scope.assessment_availability_map[res.parent_resource_id][res.config.assessment_type], function(assessm){
                  if(assessm.slug === res.slug && assessm.id === res.id){
                    add_assessment = false;
                  }
                })
                if(add_assessment){
                  scope.assessment_availability_map[res.parent_resource_id][res.config.assessment_type].push({slug:res.slug, id:res.id});
                }
              }
            })

            $log.log('POST PROCESS MAP : ' , scope.assessment_availability_map, scope.meta_mod)
          })
          .catch(function(err){
            scope.pdfModal.loading = false;
            window.alert('There was an issue retrieving the data, please try again')
            $log.log('err :  ', err)
            scope.pdfModal.visible = false;
          })
        },

        close: function() {
          this.visible = false;
        }
      }

      scope.focusOnDiagnosticMode = false;
      scope.currentResource = null;

      scope.translations_map = {};
      var trueCond = true;
      var pdf_download_disabled = false; //!LocaleService.checkUrlVersion(URL_VERSIONS.Preview);//false; //
      scope.focusOnDiagnostic = function (resource) {
        $log.log('students', scope.students)
        // $log.log('resource', resource)
        if (resource.resource_type === 'assessment' || trueCond) {
          scope.focusOnDiagnosticMode = true;
          scope.focusedResource = resource;

          // $log.log('resource.id', resource.id)
          // $log.log('userAccount.getActiveClassData().id', userAccount.getActiveClassData().id)
          // $log.log('userAccount.getActiveClassData()', userAccount.getActiveClassData())

          // $log.log('scope.currentSelectedAgenda', scope.currentSelectedAgenda)
          var date_open = scope.currentSelectedAgenda.force_redo ? scope.currentSelectedAgenda.date_open : null;
          var date_close = scope.currentSelectedAgenda.force_redo ? scope.currentSelectedAgenda.date_close : null;

          TeacherDataService.getClassAssessmentData(resource.id, userAccount.getActiveClassData().id, date_open, date_close)
          .then( function (data){
            // $log.log('data', data)
            prepareDiagnosticDrillData(data)
            //extractTranslationPacks(data);
            var tran_packs = extractTranPackList(data);
            var tran_packs_safe = encodeURIComponent(JSON.stringify(tran_packs));
            // $log.log('EXTRACTED : ' , tran_packs)
            scope.translations_map = {}
            $http.get(API_CONFIG.PDF_API+'/translation-packs?packIds='+tran_packs_safe+'&apiUrl='+encodeURIComponent(API_CONFIG.REMOTE_API)).then(function(data){
              var translations = data.data;
              $log.log('translations : ', translations)
              _.map(translations, function(pack_id, id_key){
                if(pack_id.elements){
                  _.map(pack_id.elements, function(val, element_key){
                    let content = typeof val === 'string' ? JSON.parse(val) : val;
                    scope.translations_map[TRANPACK_PREFIX+id_key+'/'+element_key] = content.text;
                  })
                }
              })
            })
            scope.onDashboardViewChange();

            eventManager.broadcast("teacher:select", { "dashboard": "Agenda", "group_id": currentClassroom.id, "agenda_id": scope.currentSelectedAgenda.id, "resource_id": resource.id });
          })
        }
      }

      scope.focusAwayFromDiagnostic = function() {
        scope.focusOnDiagnosticMode = false;
        scope.onDashboardViewChange();

        eventManager.broadcast("teacher:select:dropdown", { "dashboard": "Agenda", "group_id": currentClassroom.id, "agenda_id": scope.currentSelectedAgenda.id });
      }

      function getFirebaseTranslation(translationCodedText){
        return translation_regex_matcher(translationCodedText, translationId => {
          return scope.translations_map[translationId] && scope.translations_map[translationId][language.getCurrentSelectedLanguage()] ? scope.translations_map[translationId][language.getCurrentSelectedLanguage()].val : translationId;
        });
      }

      var translationPackAggr = []
      var translation_mapper = {};
      const TRANPACK_PREFIX = 'TRANPACK://';
      var extractTranPackList = function(asmtPerfData) {
        let aggArrProp = (arr, prop) => {
          if (arr){
            _.each( arr, t => {aggTranslationPackId(t[prop]); } );
          }
        }
        // aggArrProp(asmtPerfData.competencies, 'text'); // maybe not the right thing?
        aggArrProp(asmtPerfData.questions, 'question_translation_id');
        aggArrProp(asmtPerfData.question_response_fields, 'expected_translation_id');
        aggArrProp(asmtPerfData.question_response_fields, 'raw_text');
        for(var student_responses_key in  asmtPerfData.question_responses){
          let responses = asmtPerfData.question_responses[student_responses_key];
          if(responses){
            aggArrProp(responses, 'translation_id');
            aggArrProp(responses, 'raw_text');
          }
        }
        return translationPackAggr;
      }
      var aggTranslationPackId = function (translationCodedText) {
        if (translationCodedText){
          translation_regex_matcher(translationCodedText, translationId => {
            let path = translationId.substr(TRANPACK_PREFIX.length, translationId.length);
            let pathParts = path.split('/');
            var packId = pathParts[0];
            if (packId && translationPackAggr.indexOf(packId) === -1){
              translationPackAggr.push(packId);
            }
          })
        }
      }
      const translation_regex_matcher = function(str, iterator){
        var matched_results = str.match(/(TRANPACK:\/\/[^\s\,]+)/gm);
        if(matched_results && matched_results.length > 0){
          matched_results.forEach((result)=>{
            var new_str = iterator(result)
            str = str.replace(result, new_str)
          })
        }
        return str;
      }

      scope.diagnosticData = {
        questions: [],
        question_responses: {},
        expectedResponses: {},
        questionIdMap: {},
        calculatedValues: {},
      };

      // var responsez = {};
      scope.questionIdToUnique = {};

      var prepareDiagnosticDrillData = function(data) {
        scope.diagnosticData = {
          questions: [],
          question_responses: {},
          expectedResponses: {},
          questionIdMap: {},
          calculatedValues: {},
        };
        $log.log('pre data : ' , data)
        var questions = {};

        scope.diagnosticData.calculatedValues = data.calculatedValues;

        scope.questionIdToUnique = {};
        _.each(data.questions, function(question){
          scope.questionIdToUnique[question.question_id] = question.unique_question_id
        })

        // $log.log('scope.questionIdToUnique', scope.questionIdToUnique)

        _.map(data.question_response_fields, function(response){
          // $log.log('response', response)
          if (!scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]]) {
            scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]] = [];
          }

          // create array of all responses to the question (all revisions of the question and even all the responses to multi part questions. Filtering in template)
          scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]].push(response);
          scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]] = _.sortBy(scope.diagnosticData.expectedResponses[scope.questionIdToUnique[response.question_id]], 'question_response_order')
        })



        _.map(data.questions, function(question){
          scope.diagnosticData.questionIdMap[question.question_id] = question
        })

        // $log.log('scope.diagnosticData.questionIdMap', scope.diagnosticData.questionIdMap)
        // $log.log(scope.diagnosticData.expectedResponses)


        _.forEach(data.questions, function(a) {
          if(questions[a.unique_question_id]){
            questions[a.unique_question_id].ids[a.question_id] = a;
          } else {
            questions[a.unique_question_id] = {
              order: a.question_order,
              scene_order: a.scene_order,
              ids: { [a.question_id]: a },
            }
          }
        });

        var questionArr = _.map(questions, function(questionMap, unique_question_id){
          var questionList = _.map(questionMap.ids, function(question, question_id){
            return {
              id: parseInt(question_id),
              question: question
            }
          });

          questionList = _.orderBy(questionList, 'id', 'desc');

          return {
            unique_question_id: unique_question_id,
            order: questionMap.order,
            scene_order: questionMap.scene_order,
            list: questionList
          }
        });

        questionArr = _.orderBy(questionArr, ['scene_order', 'order'])
        scope.diagnosticData.questions = questionArr;
        // $log.log('scope.diagnosticData.questions', scope.diagnosticData.questions)

        scope.diagnosticData.responses = {};

        for (var student in data.question_responses) {
          scope.diagnosticData.responses[student] = {};
          for (var i = 0; i < data.question_responses[student].length; i++) {
            var studentID = data.question_responses[student][i];
            var questionsOnpage = scope.diagnosticData.responses[student][scope.questionIdToUnique[studentID.question_id]]
            if (!questionsOnpage) {
              questionsOnpage = [];
            }
            questionsOnpage.push(studentID);

            scope.diagnosticData.responses[student][scope.questionIdToUnique[studentID.question_id]] = _.sortBy(questionsOnpage, 'question_response_order')
          }
        }

        // $log.log('scope.diagnosticData.responses', scope.diagnosticData.responses)
        $log.log('scope.diagnosticData', scope.diagnosticData)
      }

      language.loadTranspacks(['response_error_codes']);

      scope.showResponsePopup = function(error_code_id){
        if (error_code_id){
          window.alert( language.get('TRANPACK://response_error_codes/'+error_code_id) )
        }
      }

      scope.getDiagnosticTranslation = function(raw_text, translation_id, is_response, is_correct, error_code_id) {
        if (error_code_id){
          return 'Error Code: '+error_code_id;
        }
        if(!raw_text && !translation_id && is_response && !is_correct){
          return '';
        }
        if (raw_text) {
          return getFirebaseTranslation(raw_text);
        } else {
          return getFirebaseTranslation(translation_id);
        }
      }

      scope.checkIfQuestionOutdated = function(answeredID, currentID) {
        if (answeredID) {
          return answeredID !== currentID;
        }
      }

    }
  }
});
